module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-48.3bbef8f9.png";